const environment = window._environment;
const googleAnalyticsTrackingId = window._googleAnalyticsTrackingId;
const googleTagManagerTrackingId = window._googleTagManagerTrackingId;
const googleApiClientId = window._googleApiClientId;
const datadogApplicationId = window._datadogApplicationId;
const datadogClientToken = window._datadogClientToken;
const datadogSite = window._datadogSite;
const merchantId = window._merchantId;



function returnAppConfig() {
  return {
    environment,
    googleAnalyticsTrackingId,
    googleTagManagerTrackingId,
    googleApiClientId,
    datadogApplicationId,
    datadogClientToken,
    datadogSite,
    isProductionEnvironment: ['stage', 'prod'].includes(environment),
    isTestEnvironment: ['local', 'dev', 'uat'].includes(environment),
    isLocalEnvironment: environment === 'local',
    merchantId
  };
}



export default returnAppConfig;
